import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { Spinner, SpinnerContainer, SpinnerText } from './styled';

export default function LoggingIn({ children, open = false }) {
  return (
    <Dialog open={open}>
      <DialogContent>
        <SpinnerContainer>
          <SpinnerText>{children}</SpinnerText>
          <Spinner />
        </SpinnerContainer>
      </DialogContent>
    </Dialog>
  );
}
